var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHearti = function SvgHearti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Trigger Area"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12 19.116a1.253 1.253 0 0 1-.813-.3l-1.26-1.071a38.928 38.928 0 0 1-4.095-3.78 6.289 6.289 0 0 1-1.833-4.177 4.948 4.948 0 0 1 1.237-3.326 4.4 4.4 0 0 1 3.31-1.463 4.482 4.482 0 0 1 3.453 1.651 4.484 4.484 0 0 1 3.453-1.651 4.4 4.4 0 0 1 3.31 1.463 4.952 4.952 0 0 1 1.237 3.326 6.281 6.281 0 0 1-1.834 4.177 38.534 38.534 0 0 1-4.072 3.762l-1.278 1.087a1.257 1.257 0 0 1-.815.302zM8.547 6.561a2.85 2.85 0 0 0-2.149.946 3.394 3.394 0 0 0-.837 2.282 4.851 4.851 0 0 0 1.451 3.153 37.994 37.994 0 0 0 3.915 3.6l1.073.911 1.062-.9a37.815 37.815 0 0 0 3.925-3.613 4.847 4.847 0 0 0 1.453-3.153 3.392 3.392 0 0 0-.838-2.282 2.85 2.85 0 0 0-2.149-.946 3 3 0 0 0-2.421 1.293 1.745 1.745 0 0 0-.123.21.947.947 0 0 1-1.837-.026 1.493 1.493 0 0 0-.1-.184 3 3 0 0 0-2.425-1.291z",
    "data-name": "Path 10984"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHearti);
export default ForwardRef;